// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"722":"notFound","945":"dashboard"}[chunkId] + "." + {"722":"ee9b944a","945":"246f0565"}[chunkId] + ".js";
};